import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {EffectsModule} from '@ngrx/effects';
import {StoreRouterConnectingModule} from '@ngrx/router-store';
import {rootEffects, rootMetaReducers, rootReducers} from './root.store';
import {environment} from '../../environments/environment';
import {StoreModule} from '@ngrx/store';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {AuthStoreModule} from './auth/auth-store.module';
import {ProposalStoreModule} from './proposal/proposal-store.module';
import {UserStoreModule} from './user/user-store.module';
import {CompanyStoreModule} from './company/company-store.module';

const imports = [];

if (!environment.production) {
  imports.push(
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: environment.production, // Restrict extension to log-only mode
      autoPause: true, // Pauses recording actions and state changes when the extension window is not open
    })
  );
}

@NgModule({
  imports: [
    CommonModule,
    StoreRouterConnectingModule.forRoot(),
    StoreModule.forRoot(rootReducers, {metaReducers: rootMetaReducers}),
    EffectsModule.forRoot(rootEffects),
    AuthStoreModule,
    ProposalStoreModule,
    UserStoreModule,
    CompanyStoreModule,
    ...imports,
  ],
})
export class RootStoreModule {
}
